import React, { use, useMemo } from "react";
import { Document, DocumentType } from "../../__generated__/graphql";
import { CoreMissionFieldsFragment } from "../../__generated__/operations/graphql";
import ListGroup from "../ListGroup";
import { StyleProp, ViewStyle } from "react-native";
import { IconName } from "../Icon";
import { DocumentContext } from "../../contexts/DocumentManager";
import { useI18n } from "../../hooks/i18n-hooks";
import { useNavigation } from "@react-navigation/native";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";

export type DocumentsListProps = {
    mission: CoreMissionFieldsFragment;
    testID?: string;
    style?: StyleProp<ViewStyle>;
};
type ScreenParams = StackScreenProps<RootStackParamList>;

const MissionDocumentsList: React.FC<DocumentsListProps> = ({ mission, testID, style }) => {
    const i18n = useI18n();
    const { showDocument } = use(DocumentContext);
    const navigation = useNavigation<ScreenParams["navigation"]>();
    const nonAnnexItems = useMemo(() => {
        const filteredDocuments = mission.documents?.filter(
            (doc) => doc.type !== DocumentType.MissionAnnex,
        );
        return (
            filteredDocuments?.map((document) => ({
                value: document.id || document.documentUrl || "",
                description: document.title,
                testID: document.id,
                icon: "file" as IconName,
                onPress: () => {
                    showDocument({ document });
                },
            })) || []
        );
    }, [mission.documents, showDocument]);

    const annexesCount = useMemo(() => {
        return mission.documents?.filter((doc) => doc.type === DocumentType.MissionAnnex).length;
    }, [mission.documents]);

    const allItems = useMemo(() => {
        if (annexesCount) {
            return [
                ...nonAnnexItems,
                {
                    value: "mission_annex",
                    description: i18n.t("mission.annexesTitle", {
                        count: annexesCount,
                    }),
                    testID: "mission_annex",
                    icon: "paperclip" as IconName,
                    onPress: () => {
                        navigation.navigate("MissionAnnexes", {
                            missionId: mission.id,
                        });
                    },
                },
            ];
        }
        return nonAnnexItems;
    }, [mission.id, nonAnnexItems, i18n, navigation, annexesCount]);
    return <ListGroup testID={testID} style={style} items={allItems} />;
};

export default MissionDocumentsList;
